import { EPaymentType } from '../../../../../types/reducers/paymentProcessing';

interface IParams {
  paymentType: EPaymentType | undefined;
  isPublishPaymentLaunched: boolean;
}

export const getPaymentType = (params: IParams): EPaymentType => {
  const { paymentType, isPublishPaymentLaunched } = params;

  if (paymentType) {
    return paymentType;
  }

  return isPublishPaymentLaunched ? EPaymentType.Publish : EPaymentType.Balance;
};
